<template>
  <div>
    <slot v-bind="{inputClass}" name="default">
      <v-text-field v-model="jalaliDate" v-bind="$attrs" :class="inputClass" :readonly="!editable"/>
    </slot>

    <!-- <date-picker v-model="computedValue" :custom-input="`.${inputClass}`" :display-format="getJFormat"
                 :max="max" :min="min" :range="$attrs.range" auto-submit/> -->
                 <date-picker
                  v-model="computedValue"
                  :type="type"
                  :format="isPersian ? 'jYYYY/jMM/jDD' : 'YYYY/MM/DD'"
                  :display-format="isPersian ? 'jYYYY/jMM/jDD' : 'YYYY/MM/DD'"
                  :locale="isPersian ? 'fa,en' : 'en,en'" 
                  :custom-input="`.${inputClass}`" 
                                :max="max" :min="min" :range="$attrs.range" auto-submit
                />
  </div>

</template>

<script>
export default {
  name: "custom-date-picker",

  props: {
    value: [String, Array],
    format: {
      type: String,
      default: 'datetime'
    },
    inputClass: {
      type: String,
      default: 'custom-input'
    },
    min: String,
    max: String,
    nullable: Boolean,
    sp: {
      type: String,
      default: '-'
    },
    editable: Boolean
  },

  data: () => ({
    date: '',
    jalaliDate: ''
  }),

  mounted() {
    if (!this.value && !this.nullable)
      this.computedValue = this.nowDateTimeString(this.sp)
    else {
      let val = this.value
      this.computedValue = null
      this.$nextTick(() => {
        this.computedValue = val
      })
    }
  },

  computed: {
     isPersian() {
    return this.$i18n.locale === 'fa';
  },
    computedValue: {
      get() {
        return this.value
      },
      set(val) {
        if (this.$attrs.hasOwnProperty('range'))
          this.jalaliDate = val
        else {
          if (this.format === 'time')
            this.jalaliDate = this.getTime(val)
          else
            this.jalaliDate =val;
        }

        this.$nextTick(() => {
          this.$emit('input', val)
        })
      }
    },

    getFormat: function () {
      let sp = this.sp
      switch (this.format) {
        case 'datetime':
          return `YYYY${sp}MM${sp}DD HH:mm:ss`
        case 'date':
          return `YYYY${sp}MM${sp}DD`
        case 'time':
          return 'HH:mm:ss'
      }
    },
    getJFormat: function () {
      let sp = this.sp
      switch (this.format) {
        case 'datetime':
          return `jYYYY${sp}jMM${sp}jDD HH:mm:ss`
        case 'date':
          return `jYYYY${sp}jMM${sp}jDD`
        case 'time':
          return 'HH:mm:ss'
      }
    }
  }
}
</script>

<style scoped>

</style>